/* eslint-disable react/jsx-pascal-case */
import { QueryClient, QueryClientProvider, useQuery } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import { createTheme } from '@material-ui/core/styles'
import { ThemeProvider } from '@material-ui/styles'
import P_Login from 'components/5_Pages/P_Login'
import P_CreatePassword from 'components/5_Pages/P_CreatePassword'
import P_ChangePassword from 'components/5_Pages/P_ChangePassword'
import P_Juryo from 'components/5_Pages/P1_Juryo'
import P_UserToroku from 'components/5_Pages/P4_UserToroku'
import P_Log from 'components/5_Pages/P5_Log'
import P_Sample from 'components/5_Pages/P_Sample' // サンプルページ(デバッグ用)
import { menu } from 'types/ReferTypes'
import { getTitle } from 'utils/stringUtil'
import { Provider } from 'react-redux'
import { persistor, store } from './store'
import { MediaQueryProvider, useMediaQueryContext } from 'MediaQueryProvider'
import { postFetcher } from 'utils/apiUtil'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      // suspense: true,  // ここでsuspenseモードを全体で有効化する
      // staleTime: 300000,
    },
  },
})

const theme = createTheme({
  overrides: {
    MuiTableHead: {
      root: {
        '&.MuiTableHead-root': {
          backgroundColor: '#93FFAB',
        },
      },
    },
    MuiTableRow: {
      root: {
        '&.MuiTableRow-selected:root': {
          backgroundColor: '#00CCCC',
        },
        '&.MuiTableRow-hover:hover': {
          cursor: 'pointer',
          backgroundColor: '#99CCFF',
        },
      },
    },
  },
})

const SubComponent = () => {
  // 全ページ共通項目はここで取得する
  const { error, isFetching, isLoading, data } = useQuery(['getCommonTitles', []], postFetcher<{ titles: string[]; sideMenus: menu[] }>('/getCommonTitles'))
  const titles = error || isFetching || isLoading || data == undefined ? ['…'] : data.body.titles
  const sideMenus = error || isFetching || isLoading || data == undefined ? [] : data.body.sideMenus
  const labels = {
    sysName: getTitle(titles[0]),
    sideMenus: sideMenus,
  }
  const { isMobileSite, isPcSite } = useMediaQueryContext()

  return (
    <Router>
      <Switch>
        <Route path="/" exact>
          {isPcSite && <P_Login title={getTitle(titles[0])} />}
          {isMobileSite && <P_Login title={getTitle(titles[0])} />}
        </Route>
        <Route path="/createPassword" exact>
          <P_CreatePassword title={getTitle(titles[1])} />
        </Route>
        <Route path="/changePassword" exact>
          <P_ChangePassword title={getTitle(titles[2])} />
        </Route>
        <Route path="/juryohyo">
          <P_Juryo labels={labels} />
        </Route>
        <Route path="/userToroku">
          <P_UserToroku labels={labels} />
        </Route>
        <Route path="/log">
          <P_Log labels={labels} />
        </Route>
        <Route path="/">
          <P_Sample />
        </Route>
        <Route path="/sample">
          <P_Sample />
        </Route>
      </Switch>
    </Router>
  )
}

const App = () => {
  return (
    <div className="app">
      <MediaQueryProvider>
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={false} />
          <ThemeProvider theme={theme}>
            <Provider store={store}>
              <PersistGate loading={null} persistor={persistor}>
                <SubComponent />
              </PersistGate>
            </Provider>
          </ThemeProvider>
        </QueryClientProvider>
      </MediaQueryProvider>
    </div>
  )
}

export default App
